export const ENABLE_DELIVERY = 'enable_delivery';

export const testingFlags = {
  [ENABLE_DELIVERY]: false
};
